module.exports = __webpack_public_path__ + "assets/img/C2.5efa12a7.jpg";